import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import { Link, withRouter } from "react-router"
import State from "../../stores/State"
import { dispatch } from "../../Dispatcher"
import Icon from "../elements/Icon"
import Results from "../modules/Results"
import SearchDisplayTools from "../modules/SearchDisplayTools"
import ResourceImage from "../modules/ResourceImage"
import { FormattedMessage } from "react-intl"
import { default as sharedMessages } from "../../messages/index"
import { setArticleStyle } from "../../actions"
import { width } from "../../scripts/size"
import { SET_ARTICLE_STYLES, MOBILE_ARTICLE_STYLE_ID } from "../../constants"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class Collection extends Component {
  state = {
    articleStyle: State.get("articleStyle"),
    articleStyles: SET_ARTICLE_STYLES
  }

  componentDidMount() {
    this.handleArticleStyles()
    this._stateListener = State.addListener(() => {
      const articleStyle = State.get("articleStyle")
      if (articleStyle !== this.state.articleStyle) {
        this.setState({ articleStyle })
      }
    })
    window.addEventListener("resize", this.handleArticleStyles)
  };

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
    window.removeEventListener("resize", this.handleArticleStyles)
  }

  handleArticleStyles = () => {
    if (width() <= 512) {
      this.setState({ articleStyle: MOBILE_ARTICLE_STYLE_ID })
      dispatch(setArticleStyle(MOBILE_ARTICLE_STYLE_ID))
    }
  }

  render() {
    const {
      title,
      description,
      collected: { edges: resources, pageInfo: { hasNextPage } }
    } = this.props.viewer.resources_collections[0]

    const headerImageResource = resources.length ? resources[0].node : null

    return (
      <main id="main" role="main" tabIndex={0}>
        <div className="rich-page-header" style={getStyles('rich-page-header')}>
          {getStyleTag([
            'rich-page-header__bg',
            'rich-page-header__title',
            'collections-results-panel',
            'rich-page-header__content'
          ])}
          {headerImageResource && (
            <ResourceImage
              imageSize="small"
              resource={headerImageResource}
              className="rich-page-header__bg"
            />
          )}
          <div className="rich-page-header__content"
               style={getStyles(['rich-page-header__content', 'rich-page-header__content--centered'])}>
            <div className="row column" style={getStyles('rich-page-header__content__row')}>
              <h1 className="rich-page-header__title"
                  style={getStyles(['rich-page-header__title', 'rich-page-header__bg__title'])}>
                {title}
              </h1>
              {description && <p className="rich-page-header__text">{description}</p>}
              <h3 className="rich-page-header__subtitle">
                <Link to="/collections">
                  <Icon icon="arrow-left" />
                  <FormattedMessage {...sharedMessages.backToCollections} />
                </Link>
              </h3>
            </div>
          </div>
        </div>

        <div className="page column row">
          <div className="search-results__tools search-results__tools--inpage">
            <div className="column row">
              <div className="search-results__tools-inner">
                <div className="c-results-panel search-results__panel search-results__panel--full"
                     style={getStyles(['search-results__panel'])}>
                  <SearchDisplayTools articleStyles={this.state.articleStyles} withSort={false} />
                </div>
              </div>
            </div>
          </div>
          <Results
            resources={resources}
            hasNextPage={hasNextPage}
            handleLoadMore={this.loadMore}
            articleStyle={this.state.articleStyle}
            urlParams={this.props.params}
          />
        </div>
      </main>
    )
  }

  loadMore = evt => {
    if (evt && typeof evt.preventDefault !== "undefined") {
      evt.preventDefault()
    }

    const {
      relay: { variables: { pageSize, total } },
      location: { pathname }
    } = this.props

    const newPerPage = (total || pageSize) + 20

    this.props.relay.setVariables({
      pageSize: newPerPage,
      total: newPerPage,
    })

    history.replaceState(null, null, `${pathname}?total=${newPerPage}`)
  }
}

Collection.propTypes = {
  relay: PropTypes.object.isRequired
}

export default Relay.createContainer(withRouter(Collection), {
  initialVariables: {
    pageSize: 20,
    total: null,
    slug: null
  },
  prepareVariables: prevVariables => {
    const { total } = prevVariables
    let { pageSize } = prevVariables

    if (total) {
      pageSize = total
    }

    return {
      ...prevVariables,
      pageSize
    }
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        resources_collections(slug: $slug) {
          title
          description
          collected(first: $pageSize) {
            total
            edges {
              cursor
              node {
                id
                type
                title
                custom_fields
                creator
                files {
                  id
                  width
                  height
                  type
                  images {
                    small {
                      url
                      width
                      height
                    }
                  }
                }
              }
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Collection.js